import React, { CSSProperties } from 'react'
import { Text, Divider } from '@wework/dieter-ui'
import Note from '../SidebarBlocks/Note'
import Discounts from '../SidebarBlocks/Discounts'
import SpaceAttributes from '../SidebarBlocks/SpaceAttributes'
import OfficeData from '../SidebarBlocks/OfficeData'
import InternalRooms from '../SidebarBlocks/InternalRooms'
import NotLinked from '../SidebarBlocks/NotLinked'
import BPO from '../SidebarBlocks/BPO'
import { withFloorMap } from '@wework/react-floormap'
import { useSidebar } from '../../hoc/withSidebar'
import { withSnackbar } from '../../hoc/SnackBarProvider'
import {
  CheckIsDedicatedDesk,
  CheckIsHotDesk,
} from '../../utils/EntitySynonyms'
import SpaceNameHeader from './Headers/SpaceNameHeader'
import ProductNameHeader from './Headers/ProductNameHeader'
import IMTheme from '../../style/IMTheme'
import LinkButton from './DeskLinkeage/LinkButton'
import LinkedRooms from '../SidebarBlocks/LinkedRooms'
import Row from '../Common/Row'
import _ from 'lodash'
import FloatButton from '../Common/FloatButton'
import CollapsableAvailabilityInfo from '../SidebarBlocks/CollapsableAvailabilityInfo'
import BookableSpaceAttributes from '../SidebarBlocks/BookableSpaceAttributes'
import Pricing from '../SidebarBlocks/Pricing'
import Schedule from '../SidebarBlocks/Schedule'
import Permissions from '../SidebarBlocks/Permissions'
import { EditIcon } from '../Icons'

const cardContetnStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'scroll',
  overflowX: 'hidden',
  boxSizing: 'content-box',
  width: '100%',
  paddingRight: IMTheme.spacing[4],
  marginBottom: 12,
}

const cardStyle: CSSProperties = {
  overflowY: 'hidden',
  overflowX: 'hidden',
  border: '1px solid #d1e9fa',
  borderRadius: '4px',
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  maxHeight: `100%`,
  padding: IMTheme.spacing[5],
  boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.16)',
}

function InventoryDrawer({
  space,
  onHoldClick,
  floorMap,
  snackBars,
  currentBuilding,
  isProductVisible,
  noteModalHandler,
  handleInternalRoomClick,
}: any) {
  const { openSideBar, closeSideBar } = useSidebar()

  let isBPO = false
  if (!space) return null
  if (
    space.inventoryData &&
    space.inventoryData?.relationships?.length > 0 &&
    space.inventoryData?.relationships[0]?.product_type ===
      'BOOKABLE_PRIVATE_OFFICE'
  ) {
    isBPO = true
  }

  if (space?.type === 'object' && space?.roomType !== 'CHAIR') {
    return null
  }

  const isNotLinked: boolean =
    !space.inventoryData &&
    space.inventoryData?.relationships?.length == 0 &&
    !space.reservable &&
    (space?.programType === 'MEET' || space?.programType === 'WORK') &&
    !CheckIsHotDesk(space.subType.toUpperCase()) &&
    !CheckIsDedicatedDesk(space.subType.toUpperCase())

  const getFloorName = (floorUUID: string) =>
    currentBuilding.floors.find(floor => floor.uuid === floorUUID)?.name ?? ''

  const getSpaceContent = () => {
    return (
      <div style={cardContetnStyle}>
        <Divider light style={{ margin: '20px 0 20px 0' }} />
        <OfficeData space={space} BPO={isBPO} />
        <Divider light style={{ margin: '8px 0 20px 0' }} />
        <SpaceAttributes space={space} isColapsable={false} />
        <InternalRooms
          space={space}
          floorMap={floorMap}
          getFloorName={getFloorName}
          handleInternalRoomClick={handleInternalRoomClick}
          setSelectedInternalsRooms={() => {}}
          isColapsable={false}
        />
        {!isProductVisible && (
          <>
            <div
              style={{
                height: IMTheme.spacing[5],
                margin: IMTheme.spacing[5],
              }}
            />
            <FloatButton
              icon={<EditIcon width={16} height={16} />}
              customStyle={{ boxSizing: 'border-box' }}
              onClick={() => openSideBar('EditDrawer')}
            />
          </>
        )}
      </div>
    )
  }

  const getBookableProductContent = () => {
    return (
      <div style={cardContetnStyle}>
        <Divider light style={{ margin: '20px 0 20px 0' }} />
        <BookableSpaceAttributes space={space} />
        <Note
          space={space}
          bottomBorder={false}
          noteModalHandler={noteModalHandler}
          containerStyle={{ marginBottom: IMTheme.spacing[4] }}
        />
        <Pricing space={space} />
        <Schedule space={space} />
        <Permissions space={space} />
        <Divider light style={{ margin: '0px 0 20px 0' }} />
        <Row justify="space-between">
          <Text
            style={{
              fontSize: IMTheme.fontSizes[2],
              fontWeight: IMTheme.fontWeights.bold,
            }}
          >
            Bookings
          </Text>
          <Text
            primary
            style={{
              fontSize: IMTheme.fontSizes[2],
              fontWeight: IMTheme.fontWeights.normal,
              cursor: 'pointer',
            }}
            onClick={() => {}}
          >
            View
          </Text>
        </Row>
        <FloatButton
          icon={<EditIcon width={16} height={16} />}
          customStyle={{ boxSizing: 'border-box' }}
          onClick={() => openSideBar('EditDrawer')}
        />
      </div>
    )
  }

  const getProductContent = () => {
    return (
      <div style={cardContetnStyle}>
        <Divider light style={{ margin: '20px 0 20px 0' }} />
        {isNotLinked ? (
          <NotLinked
            space={space}
            floorMap={floorMap}
            snackBars={snackBars}
            currentBuilding={currentBuilding}
          />
        ) : (
          <>
            {!isBPO && (
              <Text size="large" style={{ marginBottom: IMTheme.spacing[4] }}>
                {space.reservable?.displayPrice}
              </Text>
            )}
            {!isBPO && <Discounts space={space} floorMap={floorMap} />}
            <OfficeData space={space} BPO={isBPO} />
            {space.inventoryData?.relationships && (
              <LinkedRooms
                rooms={space.inventoryData?.relationships}
                getFloorName={getFloorName}
                handleInternalRoomClick={handleInternalRoomClick}
              />
            )}
            <Note
              space={space}
              bottomBorder
              noteModalHandler={noteModalHandler}
              containerStyle={{ marginBottom: IMTheme.spacing[2] }}
            />
            {isBPO && <BPO border containerStyle={{ marginBottom: 8 }} />}
            {!isBPO && (
              <CollapsableAvailabilityInfo
                isBPO
                space={space}
                onHoldClick={onHoldClick}
              />
            )}
            <div
              style={{
                height: IMTheme.spacing[5],
                margin: IMTheme.spacing[5],
              }}
            />
          </>
        )}
        <FloatButton
          icon={<EditIcon width={16} height={16} />}
          customStyle={{ boxSizing: 'border-box' }}
          onClick={() => openSideBar('EditDrawer')}
        />
      </div>
    )
  }

  return (
    <Row justify="space-between" style={{ height: '100%', width: '100%' }}>
      <div style={{ ...cardStyle, width: '270px' }}>
        <SpaceNameHeader space={space} />
        {getSpaceContent()}
      </div>
      {isProductVisible && (
        <>
          <div style={{ ...cardStyle, width: '343px' }}>
            <ProductNameHeader
              space={space}
              isLinked={!isNotLinked}
              onClose={closeSideBar}
            />
            {isBPO ? getBookableProductContent() : getProductContent()}
          </div>
          <div
            style={{
              position: 'absolute',
              left: '281px',
              top: '50%',
              transform: 'translateY(-50%)',
            }}
          >
            <LinkButton />
          </div>
        </>
      )}
    </Row>
  )
}
export default withSnackbar(withFloorMap()(InventoryDrawer))
